import { Typography } from "@mui/material";
import { Box } from "@mui/system";
import { HttpStatusCode } from "axios";
import React, { useContext, useEffect, useState } from "react";
import { CountdownCircleTimer } from "react-countdown-circle-timer";
import OtpField from "react-otp-field";
import { useNavigate } from "react-router-dom";
import {
  OTPVerify,
  resendOtpCall,
  // startDemo,
} from "../../../api/controllers/userController";
import { GlobalSnackBar } from "../../../components/snackBar";
import { font } from "../../../styles/font";
import { theme } from "../../../styles/theme";
import { ApplicationContext } from "../../../context/application_ctx";

export const VerifyOtp = ({
  setLoginNavigation,
  loaderState,
  setLoaderState,
  email,
  loginQuery,
}) => {
  const { setIsOpenWelcomeDialog, tokenTemp } = useContext(ApplicationContext);

  const navigate = useNavigate();
  const [OTP, setOTP] = useState("");
  const [resendTimeout, setResendTimeout] = useState(true);
  // const [loaderState, setLoaderState] = useState(false);
  const [otpSnack, setOtpSnack] = useState(false);
  const [error, setError] = useState("");
  const onOTPEntered = (e) => {
    console.log(e);
    setOTP(e);
  };

  useEffect(() => {
    console.log(OTP.length);
    const handleOTP = async () => {
      if (OTP.length === 5) {
        console.log("hello");
        setLoaderState(true);
        setTimeout(async () => {
          try {
            let response = await OTPVerify({
              email,
              otp: OTP,
            });
            console.log(response, "responseLogin");
            if (response.status === HttpStatusCode.Ok) {
              setError(response.data.message);
              setOtpSnack(true);
              setLoaderState(false);
              // apiSubscribeDemo();
              localStorage.setItem("api-token", tokenTemp);

              setTimeout(() => {
                navigate("/dashboard");
                // setLoginNavigation(2);
                setTimeout(() => {
                  setIsOpenWelcomeDialog(true); // it should only show to user first time after login
                }, 4000);
              }, 3000);
            }
            if (response.status === HttpStatusCode.BadRequest) {
              setLoaderState(false);
              setOTP("");
              setError(response.data.message);
              setOtpSnack(true);
            }
          } catch (error) {
            console.log(error);
          }
        }, 1000);
      }
    };
    handleOTP();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [OTP]);

  // const apiSubscribeDemo = async (type) => {
  //   try {
  //     let response = await startDemo(
  //       {
  //         licenseCount: 20,
  //       },
  //       tokenTemp
  //     );
  //     console.log(response, "responseLogin");
  //     if (response.status === HttpStatusCode.Ok) {
  //       setLoaderState(false);

  //       // setError(response.data.message);
  //       // setSignInSnack(true);
  //       localStorage.setItem("api-token", tokenTemp);
  //       setTimeout(() => {
  //         navigate("/dashboard");
  //         // setLoginNavigation(2);
  //         setTimeout(() => {
  //           setIsOpenWelcomeDialog(true); // it should only show to user first time after login
  //         }, 4000);
  //       }, 3000);
  //     }
  //     if (response.status === HttpStatusCode.BadRequest) {
  //       setLoaderState(false);

  //       setError(response.data.message);
  //       // setSignInSnack(true);
  //     }
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };

  const resendOtp = async (type) => {
    setLoaderState(true);
    try {
      let response = await resendOtpCall(
        {
          email,
        },
        tokenTemp
      );
      console.log(response, "responseLogin");
      if (response.status === HttpStatusCode.Ok) {
        // setLoaderState(false);
        setLoaderState(false);

        setError(response.data.message);
        setOtpSnack(true);
        setResendTimeout(true);
        setTimeout(() => {
          setResendTimeout(false);
        }, 30000);
      }
      if (response.status === HttpStatusCode.BadRequest) {
        setLoaderState(false);

        setError(response.data.message);
        setOtpSnack(true);

        // setSignInSnack(true);
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    setTimeout(() => {
      setResendTimeout(false);
    }, 30000);
  }, [resendTimeout]);
  return (
    <>
      <Box
        display={"flex"}
        flexDirection="column"
        gap="12px"
        alignItems={"center"}
        justifyContent="center"
      >
        <Typography
          fontFamily={font.family.fm_2}
          color={theme.col_6}
          textAlign="center"
          fontSize={font.size.fs_2}
          fontWeight="bold"
        >
          Check Your Email For Code
        </Typography>
        <Typography
          fontFamily={font.family.fm_2}
          color={theme.col_6}
          textAlign="center"
          fontSize={font.size.fs_3}
          fontWeight="bold"
        >
          We’ve sent a 8-character code to your email. The code expires
          shortly,so please enter it soon!
        </Typography>
        {/* <OTPInput skipDefaultStyles renderSeparator={<Box display={'flex'} width='25px' height='2px' justifyContent='center' alignItems='center'><Box display={'flex'} width='70%' height='100%' backgroundColor={theme.col_2} justifyContent='center' alignItems='center'></Box></Box>}

      renderInput={(props) => <input {...props} style={{width:'50px',height:'50px',borderRadius:'5px',border:`2px solid ${theme.col_2}`}} />} /> */}

        <OtpField
          value={OTP}
          onChange={onOTPEntered}
          numInputs={5}
          onChangeRegex={/^([0-9]{0,})$/}
          autoFocus
          separator={<span>-</span>}
          isTypeNumber
          inputProps={{
            className: loginQuery ? "otp-field__input_sm" : "otp-field__input",
            disabled: false,
          }}
          sx={{ justifyContent: "center" }}
        />
        <Box
          display="flex"
          width="80%"
          gap="10px"
          alignItems="center"
          justifyContent="flex-end"
        >
          {resendTimeout ? (
            <>
              {" "}
              <Typography
                fontFamily={font.family.fm_2}
                color={theme.col_2}
                textAlign="center"
                fontSize={font.size.fs_3}
                fontWeight="bold"
                display="flex"
                alignItems="center"
                gap="10px"
              >
                Resend code in
                <CountdownCircleTimer
                  size={40}
                  strokeWidth={3}
                  isPlaying
                  duration={30}
                  colors={[
                    `${theme.col_2}`,
                    `${theme.col_3}`,
                    `${theme.col_2}`,
                    `${theme.col_3}`,
                  ]}
                  colorsTime={[1, 1, 1, 0]}
                >
                  {({ remainingTime }) => remainingTime}
                </CountdownCircleTimer>
              </Typography>
            </>
          ) : (
            <Typography
              sx={{ cursor: "pointer" }}
              onClick={resendOtp}
              fontFamily={font.family.fm_2}
              color={theme.col_2}
              textAlign="center"
              fontSize={font.size.fs_3}
              fontWeight="bold"
            >
              Resend OTP?
            </Typography>
          )}
        </Box>
      </Box>
      <GlobalSnackBar open={otpSnack} title={error} close={setOtpSnack} />

      {/* <Box
        display="flex"
        alignItems={"center"}
        justifyContent="center"
        width="74%"
        padding="15px"
        borderRadius="15px"
        backgroundColor={"#ffe3e3"}
      >
        <Typography
                fontFamily={font.family.fm_2}
          color={"#ff4c4c"}
          textAlign="center"
          // fontSize={font.size.fs_4}
          fontFamily={font.family.fm_1}
          fontWeight="bold"
        >
          Error
        </Typography>
      </Box> */}
      {/* <Typography
                fontFamily={font.family.fm_2}>wedfscx</Typography> */}
    </>
  );
};
